import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { COLOR_PRIMARY, COLOR_WHITE } from "../../constants/color";
import { Logo } from "../atoms/LogoWithBG";

type Props = {
  hideLogo?: boolean;
};

export const LoginTemplate: React.FC<Props> = ({ hideLogo }) => {
  return (
    <StyledLoginTemplateContainer>
      <StyledContentWrapper>
        {!hideLogo && (
          <StyledLogoContainer>
            <Logo width={230} height={230} />
          </StyledLogoContainer>
        )}

        <StyledFormContainer>
          <Outlet />
        </StyledFormContainer>
      </StyledContentWrapper>
    </StyledLoginTemplateContainer>
  );
};

const StyledLoginTemplateContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  padding: 5px 0px;
  justify-content: center;
  align-items: center;
  background-color: ${COLOR_WHITE};
  overflow: hidden;
`;

const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 100vh;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 990px) {
    padding: 16px;
  }
`;

const StyledLogoContainer = styled.div`
  flex-shrink: 0;

  @media (max-width: 990px) {
    margin-bottom: 0px;
  }
`;

const StyledFormContainer = styled.div`
  flex-shrink: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
